export default "__VITE_ASSET__aj9sErJN__"